import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isOpen ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "width": "420"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm.setupStep === 0 ? [_c('img', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto 16px auto"
    },
    attrs: {
      "src": _vm.qrImage,
      "width": "240"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_p1')))]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_p2')))]), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    staticStyle: {
      "display": "block",
      "margin": "24px auto 0 auto !important"
    },
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.handleQrCodeScanned
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-arrow-right")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_btn')) + "\n    ")], 1)] : _vm._e(), _vm.setupStep === 1 ? [_c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.verifyToken_p1')))]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.verifyToken_p2')))]), _c(VTextField, {
    staticStyle: {
      "display": "block",
      "margin": "24px auto 0 auto !important",
      "max-width": "200px"
    },
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "autofocus": "",
      "error": _vm.errorVerify,
      "label": "6-Digit Code",
      "maxlength": 6,
      "error-messages": _vm.errorVerify ? _vm.$i18n_t('Common.multiFactorAuth.verifyToken_error') : ''
    },
    on: {
      "input": _vm.handleCodeChanged,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleCodeEntered.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputVerifyToken,
      callback: function ($$v) {
        _vm.inputVerifyToken = $$v;
      },
      expression: "inputVerifyToken"
    }
  }), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    staticStyle: {
      "display": "block",
      "margin": "8px auto 0 auto !important"
    },
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": "",
      "disabled": _vm.inputVerifyToken.length !== 6
    },
    on: {
      "click": _vm.handleCodeEntered
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-arrow-right")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.verifyToken_btn')) + "\n    ")], 1)] : _vm._e(), _vm.setupStep === 2 ? [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.recoveryCodes_p1')))]), _c('p', [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.recoveryCodes_p2')) + "\n    ")]), _c('ul', {
    staticClass: "recovery-codes"
  }, _vm._l(_vm.recoveryCodes, function (code, index) {
    return _c('li', {
      key: `key-${index}`
    }, [_vm._v("\n        " + _vm._s(code) + "\n        "), _c('br')]);
  }), 0), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    staticStyle: {
      "display": "block",
      "margin": "24px auto 0 auto !important"
    },
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.recoveryCodes_btn')) + "\n    ")])] : _vm._e()], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };